export enum QuestionnaireItemSubtype {
	RADIO_LIST = 'radio_list',
	CHECKBOX_LIST = 'checkbox_list',
	ADD_QUESTION = 'add_question',
	PREPEND_QUESTION = 'prepend_question',
	SHOW_NOTIFICATION = 'show_notification',
	SHOW_ALERT = 'show_alert',
	SCALE_LIST = 'scale_list',
	TEXTAREA = 'textarea',
	FRAMED = 'framed',
	SUBTITLE = 'subtitle',
	LIST_ITEM = 'listItem',
	NUMBER_FIELD = 'numberfield',
	DATE = 'date',
}
